import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { PayWithCardComponent } from './pay-with-card.component';

// TODO - remove when paymentPanel STAB-908 (DEV-18469)
export const ngxPayWithCardModule = angular.module('ngxPayWithCardModule', [])
	.directive('ngxPayWithCard', downgradeComponent({ component: PayWithCardComponent }))
	.name;
